import React, { useEffect } from 'react';
import { Cards } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Icon from '@mdi/react';
import { mdiArrowDecisionAuto, mdiCloseOctagon, mdiFolderArrowLeftRight, mdiInvoiceTextArrowLeft, mdiShieldAccount, mdiWebCancel } from '@mdi/js';

const pageSize = 20;

export const SecurityPage = () => {
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    useEffect(() => {
        //handleRefresh();
    }, []);
    const handleOption = (ref: string) => {
        window.location.href = ref
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Seguridad', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Cards
                        selectionType="single"
                        onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
                        cardDefinition={{

                            header: item => item.name
                            ,
                            sections: [
                                {
                                    header: "",
                                    content: item => item.description
                                },
                            ]
                        }}
                        cardsPerRow={[
                            { cards: 1 },
                            { minWidth: 500, cards: 3 }
                        ]}
                        entireCardClickable
                        items={[
                            {
                                id: "#security/policies",
                                name: (
                                    <span>
                                        <Icon path={mdiInvoiceTextArrowLeft} size={1.5} />Políticas</span>),
                                description: "Generador de políticas de acceso basadas en horario y días semanales",
                            },
                            {
                                id: "#security/exclusions",
                                name: (
                                    <span>
                                        <Icon path={mdiArrowDecisionAuto} size={1.5} />Exclusiones</span>),
                                description: "Configuración de anulación de aperturas remotas para accesos basado en horario y días semanales",
                            },
                            {
                                id: "#security/assign",
                                name: (
                                    <span>
                                        <Icon path={mdiFolderArrowLeftRight} size={1.5} />Asignaciones</span>),
                                description: "Permite asignar una o más políticas de acceso a un acceso, unidad o usuario",
                            },
                            {
                                id: "#security/geolocalization",
                                name: (
                                    <span>
                                        <Icon path={mdiWebCancel} size={1.5} />Geolocalización</span>),
                                description: "Configuración de restricciones de distancia mínima sobre uno o más accesos",
                            },
                            {
                                id: "#security/blocks",
                                name: (
                                    <span>
                                        <Icon path={mdiCloseOctagon} size={1.5} />Bloqueos</span>),
                                description: "Anular los servicios de LlaveMovil temporalemente a un acceso, unidad o usuario",
                            },
                        ]}
                        header={<Header><Icon path={mdiShieldAccount} size={2} /> Seguridad</Header>}
                    />
                </>
            }
        />
    );
};
